import { render, staticRenderFns } from "./priceInput.vue?vue&type=template&id=23e9efb6&"
import script from "./priceInput.vue?vue&type=script&lang=js&"
export * from "./priceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports